module.exports = __webpack_public_path__ + "static/img/1-2.654292a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/events/summer2018/app_screen/section-1/1-2.jpg
// module id = 726
// module chunks = 1